var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19259 19C3.58317 19 3.08696 18.5042 3.08696 17.8944V10.155L1.11894 10.1563C0.514384 10.1563 0.0181776 9.6654 0.0128706 9.06129L4.56048e-05 7.73321C-0.0026079 7.43557 0.110608 7.15563 0.320236 6.94467C0.528978 6.73328 0.808039 6.61696 1.10567 6.61696H3.08696V4.62683C3.08696 1.64341 4.60919 0 7.37282 0C8.46606 0 9.42044 0.0773939 9.42929 0.0782784C9.85606 0.116312 10.1771 0.46746 10.1771 0.895117V2.91621C10.1771 3.36819 9.80918 3.73614 9.3572 3.73614H8.07113C7.53291 3.73614 7.09464 4.17397 7.09464 4.71263L7.06988 6.61696H9.03259C9.34791 6.61696 9.64864 6.75229 9.85827 6.98757C10.0679 7.22285 10.1674 7.53729 10.1307 7.8504L9.97635 9.17716C9.91178 9.73484 9.43946 10.155 8.87868 10.155H7.06722V17.8944C7.06722 18.5042 6.57102 19 5.96159 19H4.19259Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0ece5277f42df66a9e26fe8a57e85475.svg";
export { ForwardRef as ReactComponent };